import { render, staticRenderFns } from "./motoInfo.vue?vue&type=template&id=33d2b5b8&scoped=true&"
import script from "./motoInfo.vue?vue&type=script&lang=js&"
export * from "./motoInfo.vue?vue&type=script&lang=js&"
import style0 from "./motoInfo.vue?vue&type=style&index=0&id=33d2b5b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d2b5b8",
  null
  
)

export default component.exports